import React from "react";
import ReactDatePicker from "react-datepicker";
import { useController } from "react-hook-form";
import { ko } from "date-fns/esm/locale";

const DATE_PICKER_TYPE = {
	DATE: "date",
	MONTH: "month",
	QUARTER: "quarter",
	YEAR: "year",
};

const DATE_FORMAT = {
	[DATE_PICKER_TYPE.DATE]: "yyyy. MM. dd.",
	[DATE_PICKER_TYPE.MONTH]: "yyyy. MM",
	[DATE_PICKER_TYPE.QUARTER]: "yyyy년 q분기",
	[DATE_PICKER_TYPE.YEAR]: "yyyy",
};

const DatePicker = ({
	getValue,
	card,
	control,
	name,
	validation,
	defaultValue,
	datePickerName,
	required,
	month,
	year,
	quarter,
	readonly,
}) => {
	const type = year
		? DATE_PICKER_TYPE.YEAR
		: quarter
		? DATE_PICKER_TYPE.QUARTER
		: month
		? DATE_PICKER_TYPE.MONTH
		: DATE_PICKER_TYPE.DATE;

	const { field } = useController({
		control,
		name,
		rules: { required: required && "필수 입력 사항 입니다.", ...validation },
		defaultValue: defaultValue ? defaultValue : new Date(),
	});

	return (
		<ReactDatePicker
			onChange={(date) => {
				field.onChange(date);
				getValue && getValue(new Date(date), card);
			}}
			selected={new Date(field.value)}
			dateFormat={DATE_FORMAT[type]}
			className={"c__input c__datePicker " + (datePickerName ? datePickerName : "")}
			showYearDropdown
			showQuarterYearPicker={type === "quarter"}
			showMonthYearPicker={type === "month"}
			showFullMonthYearPicker={type === "date"}
			useShortMonthInDropdown
			dateFormatCalendar=" "
			// showYearDropdown
			showMonthDropdown
			dropdownMode="select"
			locale={ko}
			readOnly={readonly}

			// startDate={startDate}
			// endDate={endDate}
			// selectsRange
			// inline
			// renderCustomHeader={({
			// 						 date,
			// 						 changeYear,
			// 						 changeMonth,
			// 						 decreaseMonth,
			// 						 increaseMonth,
			// 						 prevMonthButtonDisabled,
			// 						 nextMonthButtonDisabled,
			// 					 }) => (
			// 	<div
			// 	>
			// 		<button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
			// 			{"<"}
			// 		</button>
			// 		<select/>
			// 		<button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
			// 			{">"}
			// 		</button>
			// 	</div>
			// )}
		/>
		// <div
		// 	className={`c__select f__item ${className} ${selectToggle ? "open" : ""}`}
		// 	tabIndex={0}
		// 	onKeyDown={(e) => e.key === "Tab" && setSelectToggle(false)}
		// 	onFocus={() => {
		// 		setSelectToggle(true);
		// 	}}
		// 	onBlur={() => {
		// 		setSelectToggle(false);
		// 	}}
		// >
		// 	<p
		// 		className={`c__selection-item`}
		// 		onMouseDown={() => {
		// 			setSelectToggle(!selectToggle);
		// 		}}
		// 	>
		// 		{field.value === undefined || field.value === null ? (
		// 			<span className="placeholder">{placeholder}</span>
		// 		) : (
		// 			<span>{(options.find((v) => v.value === field.value) || {}).label}</span>
		// 		)}
		// 		<DownArrowIcon />
		// 	</p>
		// 	<ul className="c__select-dropdown">
		// 		{options.map((option, index) => (
		// 			<li
		// 				key={index}
		// 				className={`c__select-dropdown-item ${
		// 					field.value === option.value && "selected"
		// 				}`}
		// 				onClick={() => {
		// 					field.onChange(option.value);
		// 					setSelectToggle(false);
		// 				}}
		// 			>
		// 				{option.label}
		// 			</li>
		// 		))}
		// 	</ul>
		// </div>
	);
};

export default DatePicker;
